var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin registration-page"},[_c('registration-form',{attrs:{"submit":_vm.register,"errorMessage":_vm.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }